import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { IApiResponse } from '@web/shared-types';
import { IServiceArea } from '@web/dtos';
import { firstValueFrom } from 'rxjs';
import { ServiceAreaGateway } from './service-area.gateway';

@Injectable({
  providedIn: 'root',
})
export class ServiceAreaStore {
  private readonly gateway: ServiceAreaGateway = new ServiceAreaGateway();

  readonly #serviceAreasResource: ResourceRef<
    IApiResponse<IServiceArea[]> | undefined
  > = resource({
    loader: (): Promise<IApiResponse<IServiceArea[]>> =>
      firstValueFrom(this.gateway.list()),
  });

  readonly serviceAreas: Signal<IServiceArea[]> = computed(
    (): IServiceArea[] =>
      this.#serviceAreasResource.hasValue()
        ? (this.#serviceAreasResource.value()?.data ?? [])
        : []
  );
  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#serviceAreasResource.isLoading()
  );

  reload(): void {
    this.#serviceAreasResource.reload();
  }
}
